var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 390 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_448_3081)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.43356e-06 61.6L21.8333 54.2575C43.6667 47.025 87.3333 32.175 131 36.6575C174.667 40.975 218.333 64.625 262 73.3425C305.667 82.225 349.333 76.175 371.167 73.3425L393 70.4L393 1.90486e-05L371.167 2.09573e-05C349.333 2.28661e-05 305.667 2.66835e-05 262 3.0501e-05C218.333 3.43185e-05 174.667 3.81359e-05 131 4.19534e-05C87.3333 4.57708e-05 43.6667 4.95883e-05 21.8333 5.1497e-05L-6.8188e-06 5.34058e-05L-1.43356e-06 61.6Z",
    fill: "#096784"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_448_3081"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 393,
    height: 88,
    fill: "white",
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 0 88)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.21ed90f3aeebba70e6d8ce73053fbf8f.svg";
export { ForwardRef as ReactComponent };